document.addEventListener("DOMContentLoaded", () => {
  const allTables = document.querySelectorAll(".table");
  allTables.forEach((table) => {
    if (table.querySelector("#dynamic-sticky-header")) {
      setupDynamicHeader(table);
    }
    if (table.querySelector(".table__popover-trigger")) {
      initTablePopovers(table);
    }
    setupOverlayScroller(table);
  });
});

const initTablePopovers = (tableElement) => {
  const popoverTriggers = tableElement.querySelectorAll(
    ".table__popover-trigger",
  );

  if (popoverTriggers.length === 0) return;

  initPopoverElements(tableElement);

  popoverTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const row = trigger.dataset.row;
      const cell = trigger.dataset.cell;
      const popoverId = `popover-${row}-${cell}`;
      const originalPopover = document.getElementById(popoverId);

      if (originalPopover) {
        hideAllPopoverClones();

        const clone = createPopoverClone(originalPopover);
        positionPopoverClone(clone, trigger);
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (
      !e.target.closest(".table__popover-trigger") &&
      !e.target.closest(".table__popover")
    ) {
      hideAllPopoverClones();
    }
  });
};

const initPopoverElements = (tableElement) => {
  const popovers = tableElement.querySelectorAll(".table__popover");
  popovers.forEach((popover) => {
    popover.style.visibility = "hidden";
    popover.style.opacity = "0";
    popover.style.display = "block";
  });
};

const createPopoverClone = (originalPopover) => {
  const existingClone = document.getElementById(`${originalPopover.id}-clone`);
  if (existingClone) {
    existingClone.remove();
  }

  const clone = originalPopover.cloneNode(true);
  clone.id = `${originalPopover.id}-clone`;

  clone.style.visibility = "visible";
  clone.style.opacity = "1";
  clone.style.display = "block";
  clone.style.zIndex = "9999";

  document.body.appendChild(clone);
  return clone;
};

const positionPopoverClone = (clone, trigger) => {
  const triggerRect = trigger.getBoundingClientRect();

  const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollY = window.pageYOffset || document.documentElement.scrollTop;

  const triggerLeft = triggerRect.left + scrollX;
  const triggerTop = triggerRect.top + scrollY;

  const cloneRect = clone.getBoundingClientRect();

  let left = triggerLeft + triggerRect.width / 2 - cloneRect.width / 2;

  if (left < scrollX + 8) {
    left = scrollX + 8;
  } else if (left + cloneRect.width > scrollX + window.innerWidth - 8) {
    left = scrollX + window.innerWidth - cloneRect.width - 8;
  }

  const popoverTop = triggerTop - 8;

  clone.style.left = `${left}px`;
  clone.style.top = `${popoverTop}px`;
  clone.style.bottom = "auto";

  clone.style.transformOrigin = "bottom left";
  clone.style.transform = "translateY(-100%)";
};

const hideAllPopoverClones = () => {
  const clones = document.querySelectorAll("[id$='-clone']");
  clones.forEach((clone) => {
    clone.remove();
  });
};

const setupDynamicHeader = (tableElement) => {
  const table = tableElement;
  const dynamicHeader = table.querySelector("#dynamic-sticky-header");
  const dynamicHeaderText = table.querySelector("#dynamic-header-text");
  const chapterHeaders = table
    .querySelector(".table__wrapper")
    .querySelectorAll(".table__row--chapter-header");
  const stickyHeaders = table.querySelector(".table__sticky-headers");
  const tableWrapper = table.querySelector(".table__wrapper");
  let isVisible = false;

  if (!dynamicHeader || chapterHeaders.length === 0) {
    return;
  }

  if (stickyHeaders && tableWrapper) {
    const stickyHeaderElements = [
      table.querySelector(".table__sticky-header--top"),
      table.querySelector(".table__sticky-header--dynamic"),
    ].filter(Boolean);

    const mainTable = tableWrapper.querySelector(".table__element");

    const syncHeaderWidths = () => {
      if (mainTable) {
        stickyHeaderElements.forEach((header) => {
          const headerTable = header.querySelector(".table__element");
          if (headerTable) {
            headerTable.style.width = `${mainTable.scrollWidth}px`;
          }
        });
      }
    };

    tableWrapper.addEventListener("scroll", () => {
      stickyHeaderElements.forEach((header) => {
        header.style.transform = `translateX(-${tableWrapper.scrollLeft}px)`;
      });
    });

    syncHeaderWidths();
    if (window.ResizeObserver && mainTable) {
      const resizeObserver = new ResizeObserver(syncHeaderWidths);
      resizeObserver.observe(mainTable);
    }
  }

  const handleScroll = () => {
    let currentChapter = null;
    const topStickyOffset = 50;

    chapterHeaders.forEach((header) => {
      const headerRect = header.getBoundingClientRect();
      const headerTop = headerRect.top;

      if (headerTop <= topStickyOffset) {
        currentChapter = header;
      }
    });

    if (currentChapter) {
      const title = currentChapter.getAttribute("data-chapter-title");
      showDynamicHeader(title);
    } else {
      hideDynamicHeader();
    }
  };

  const showDynamicHeader = (title) => {
    if (!isVisible || dynamicHeaderText.textContent !== title) {
      dynamicHeaderText.textContent = title;
      dynamicHeader.classList.add("show");
      isVisible = true;
    }
  };

  const hideDynamicHeader = () => {
    if (isVisible) {
      dynamicHeader.classList.remove("show");
      isVisible = false;
    }
  };

  const destroy = () => {
    window.removeEventListener("scroll", handleScroll);
  };

  const init = () => {
    window.addEventListener("scroll", handleScroll);
    handleScroll();
  };

  init();

  return {
    destroy: destroy,
  };
};

const setupOverlayScroller = (tableElement) => {
  const overlayScroller = tableElement.querySelector(
    ".table__overlay-scroller",
  );
  const scrollContent = tableElement.querySelector(".table__scroll-content");
  const tableWrapper = tableElement.querySelector(".table__wrapper");
  const tableElementInner = tableElement.querySelector(".table__element");

  if (
    !overlayScroller ||
    !scrollContent ||
    !tableWrapper ||
    !tableElementInner
  ) {
    return;
  }

  const updateScrollWidth = () => {
    const tableWidth = tableElementInner.scrollWidth;
    const wrapperWidth = tableWrapper.clientWidth - 80;
    const needsScroll = tableWidth > wrapperWidth;

    if (needsScroll) {
      scrollContent.style.width = `${tableWidth}px`;
      overlayScroller.style.display = "block";

      const tableRect = tableElement.getBoundingClientRect();
      const isVisible =
        tableRect.top < window.innerHeight && tableRect.bottom > 0;
      overlayScroller.style.opacity = isVisible ? "1" : "0";
    } else {
      overlayScroller.style.display = "none";
    }
  };

  overlayScroller.addEventListener("scroll", () => {
    tableWrapper.scrollLeft = overlayScroller.scrollLeft;
  });

  tableWrapper.addEventListener("scroll", () => {
    overlayScroller.scrollLeft = tableWrapper.scrollLeft;
  });

  const handleScroll = () => {
    const tableRect = tableElement.getBoundingClientRect();
    const isVisible =
      tableRect.top < window.innerHeight && tableRect.bottom > 0;
    const needsScroll =
      tableElementInner.scrollWidth > tableWrapper.clientWidth - 80;

    if (needsScroll && isVisible) {
      overlayScroller.style.opacity = "1";
    } else {
      overlayScroller.style.opacity = "0";
    }
  };

  updateScrollWidth();
  window.addEventListener("resize", updateScrollWidth);
  window.addEventListener("scroll", handleScroll);
};
